import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CameraIndoorIcon(props: IconProps) {
    return <Icon {...props} iconKey={"camera_indoor"}/>
}
